












import { Component, Prop, Vue } from 'vue-property-decorator';

import * as def from '@/definitions'

@Component({
  components: {
  },
})
export default class CodeCell extends Vue 
{
    @Prop() private selected! : boolean;
    @Prop() private code! : { type : string }

    private onClick()
    {
        this.$emit("select");
    }
   
}
